import { useEffect } from 'react';
import Features from './Features';
import Header from './Header';
import HeroSection from './HeroSection';
import Footer from './Footer';
import StartupRecognition from './StartupRecognition';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function HomePage() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id='App' className="App" style={{ overflow: isHome ? "visible" : "hidden" }}>
      <Helmet>
        <title>Manufacturing ERP Software for Inventory & GST | Ease Margin</title>
        <meta
          name="description"
          content="Ease Margin is a manufacturing ERP software for inventory, production, GST billing, sales, and purchase management. Boost margins with real-time insights."
        />
        <link rel="canonical" href="https://easemargin.com/" />
      </Helmet>
      <Header />
      <HeroSection />
      <Features />
      <StartupRecognition />
      <Footer />
    </div>
  );
}

export default HomePage;
